<template>
  <div class="base-form-div scene-bookmark">
    <el-form
      size="mini"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
    </el-form>
    <div class="list">
      <el-image @click="flyToView(ruleForm)" :src="ruleForm.data"></el-image>
    </div>
    <div class="form-bottom">
      <el-button
        class="base-button"
        size="mini"
        type="primary"
        @click="submitForm('ruleForm')"
        >确定</el-button
      >
      <el-button class="base-button" size="mini" @click="addForm('ruleForm')"
        >添加</el-button
      >
    </div>
  </div>
</template>
<script>
import DrawHelper from "../lib/DrawPolyline.js";
let DrawUti = undefined;
import * as Help from "./help";
let plotArr = [];
import DrawPolyline from "@/utils/cesiumBD/plot/DrawPolyline.js";
let DrawPolylineUti = undefined;
export default {
  props: ["subData"],
  data() {
    return {
      typeOptions: [],
      ruleForm: {
        name: "",
        data: null,
        type: "sceneBookmark",
        typeName: "场景书签",
        delay: 1,
      },
      rules: {},
      drawDone: false,
    };
  },
  created() {
    if (this.subData) {
      this.ruleForm = this.subData;
    }
  },
  methods: {
    flyToView() {},
    getPlot(plot) {
      var keyPos = plot.polyline.positions.getValue();
      if (keyPos.length < 1) {
        return;
      }
    },
    createLineEntity(positions) {
      var line = viewer.entities.add({
        show: true,
        polyline: {
          positions: positions,
          show: true,
          material: Cesium.Color.RED,
          width: 3,
          clampToGround: true,
          disableDepthTestDistance: Number.MAX_VALUE,
        },
      });
      return line;
    },
    drawLine() {
      if (!DrawPolylineUti) {
        DrawPolylineUti = new DrawPolyline({
          canEdit: true,
          callback: this.getPlot,
        });
      }

      DrawPolylineUti.reset();
      DrawPolylineUti.start();
      this.drawDone = true;
    },
    addForm() {
      if (this.subData) {
        this.$parent.close();
        return;
      }
      this.$bus.$emit("addActionObj", JSON.parse(JSON.stringify(this.ruleForm)));
      this.resetForm("ruleForm");
      this.$parent.close();
    },
    submitForm() {
      var url = DBmap.expImage();
      var view = DBmap.getCameraView();
      var item = new Object();
      this.ruleForm.data = url;
      this.ruleForm.view = view;
      this.$message({
        message: "添加成功",
        type: "success",
      });
    },
    resetForm() {
      DrawPolylineUti && DrawPolylineUti.clear();
      this.ruleForm.data = null;
      this.drawDone = false;
      for (let i = 0; i < plotArr.length; i++) {
        viewer.entities.remove(plotArr[i]);
      }
    },
  },

  beforeDestroy() {
    DrawPolylineUti && DrawPolylineUti.clear();
    DrawPolylineUti = undefined;
    viewer.clock.multiplier = 1;
    for (let i = 0; i < plotArr.length; i++) {
      viewer.entities.remove(plotArr[i]);
    }
  },
};
</script>
<style>
.form-bottom {
  margin-bottom: 0 !important;
  text-align: center;
}

.el-input-number {
  width: 100%;
}
.scene-bookmark .list {
  width: 80%;
  margin: auto;
  padding-left: 20px;
}
</style>
